import type * as yup from 'yup';

import { pkwSchema } from '@/features/Sparten/pkw/schema/schema';
import { genericStoreFactory } from '@/utils/genericStoreFactory/genericStoreFactory';

export const inputSchema = pkwSchema;

export type InputStore = yup.Asserts<typeof inputSchema>;

export const usePkwInputStore = genericStoreFactory(
  () => inputSchema.getDefault(),
  'PkwInputStore',
);
